<div class="card" *ngIf="project">  
  <div class="card-body">
    <div class="row">
      <div class="col">
        <sc-status-progress style="max-width: 45rem;" [selected-status]="progress" *ngIf="project.Type == 'Full'">
          <sc-status-progress-item value="analysis" [label]="texts.progress.analysis | localize">
          </sc-status-progress-item>
          <!-- <sc-status-progress-item value="talents" [label]="texts.progress.talents | localize">
          </sc-status-progress-item> -->
          <sc-status-progress-item value="outreach" [label]="texts.progress.outreach | localize">
          </sc-status-progress-item>
          <sc-status-progress-item value="applications" [label]="texts.progress.applications | localize">
          </sc-status-progress-item>
        </sc-status-progress>

        <sc-status-progress style="max-width: 45rem;" [selected-status]="progress" *ngIf="project.Type == 'Longlist'">
          <sc-status-progress-item value="analysis" [label]="texts.progress.analysis | localize">
          </sc-status-progress-item>
          <sc-status-progress-item value="talents" [label]="texts.progress.talents | localize">
          </sc-status-progress-item>
          <!-- <sc-status-progress-item value="outreach" [label]="texts.progress.outreach | localize">
          </sc-status-progress-item>
          <sc-status-progress-item value="applications" [label]="texts.progress.applications | localize">
          </sc-status-progress-item> -->
        </sc-status-progress>
      </div>
      @if (project.Status == 'AwaitingOrder')
      {
        <div class="col-auto">
          <button class="btn btn-dark" (click)="start.emit(project)">{{ texts.startSourcing | localize }} <i
              class="fa-sharp fa-solid fa-arrow-right ms-2"></i></button>
        </div>
      }
    </div>

  </div>
</div>

<div class="card mt-5">
  <div class="card-img-top" *ngIf="project">
    <img class="img-fluid" *ngIf="project.Image" [src]="project.Image | imageSize : 1200 : 395" />
    <img class="img-fluid" *ngIf="!project.Image"
      src="/assets/project-hero-placeholder/hero-placeholder-{{getImageIndex()}}.jpg" />
  </div>
  <div class="card-body">



    <div *ngIf="project">

      <!-- <div class="row mb-5 align-items-center">

    <div class="col">
      <a routerLink="/projects" class="link-arrow left">{{ texts.positionsLink | localize }}</a>
    </div>

    <div class="col-auto">
      <app-project-base-user-card [project]="project"></app-project-base-user-card>
    </div>


  </div> -->

      <app-editable-section [isEditable]="isEditable" (onEdit)="editModal.show()">
        <div class="row header-row">
          <div class="col col-xl-10">

            <div class="row">
              <!-- <div class="col-11 col-xl-12 mb-3">
            <div class="row">
              <div class="col">
                <span class="h1">{{ project.Name }}</span>&nbsp;<span class="small ms-2">{{ texts.genderSuffix | localize }}</span>
              </div>
            </div>

          </div> -->

              <ul class="col-12 list-inline mb-n2">
                <li class="list-inline-item mb-2" *ngIf="project.Profile?.Locations?.length == 1">
                  <i class="me-1 size-1 fa-sharp fa-solid fa-location-dot"></i> {{ project.Profile?.Locations[0].City }}
                </li>
                <li class="list-inline-item mb-2" *ngIf="project.Profile?.Locations?.length == 2">
                  <i class="me-1 size-1 fa-sharp fa-solid fa-location-dot"></i> {{ project.Profile?.Locations[0].City }}
                  {{
                  texts.oneMore | localize }}
                </li>
                <li class="list-inline-item mb-2" *ngIf="project.Profile?.Locations?.length > 2">
                  <i class="me-1 size-1 fa-sharp fa-solid fa-location-dot"></i> {{ project.Profile?.Locations[0].City }}
                  +
                  {{ project.Profile?.Locations?.length - 1}} {{ texts.moreSuffix | localize }}
                </li>

                <li class="list-inline-item mb-2"
                  *ngIf="project.Profile.Compensation.MinSalary && project.Profile.Compensation.MaxSalary && project.Type != 'Longlist' && !isSalaryHidden(project.Id)">
                  <i class="me-1 size-1 fa-sharp fa-solid fa-money-bill-wave"></i> {{
                  project.Profile.Compensation.MinSalary
                  | number }} – {{ project.Profile.Compensation.MaxSalary | number }}{{
                  project.Profile.Compensation.SalaryCurrency }}
                </li>

                <li class="list-inline-item mb-2" *ngIf="project.Profile.MaxRemote && project.Type != 'Longlist'">
                  <i class="fa-sharp fa-solid fa-house"></i> {{ texts.remoteUpTo | localize }} {{
                  project.Profile.MaxRemote
                  | number }}%
                </li>

                <li class="list-inline-item mb-2" *ngIf="project.Profile?.EmploymentType == 'Permanent'">
                  <i class="me-1 size-1 fa-sharp fa-solid fa-clock"></i> {{ texts.permanent | localize }}
                </li>
                <li class="list-inline-item mb-2" *ngIf="project.Profile?.EmploymentType == 'Interim'">
                  <i class="me-1 size-1 fa-sharp fa-solid fa-clock"></i> {{ texts.fixedTerm | localize }}
                </li>
                <li class="list-inline-item mb-2" *ngIf="project.Profile?.EmploymentType == 'Freelancer'">
                  <i class="me-1 size-1 fa-sharp fa-solid fa-clock"></i> {{ texts.freelancer | localize }}
                </li>

                <li class="list-inline-item mb-2" *ngIf="project.Profile?.IsFullTime && !project.Profile?.IsPartTime">
                  <i class="me-1 size-1 fa-sharp fa-solid fa-file-signature"></i> {{ texts.fullTime | localize }}
                </li>
                <li class="list-inline-item mb-2" *ngIf="!project.Profile?.IsFullTime && project.Profile?.IsPartTime">
                  <i class="me-1 size-1 fa-sharp fa-solid fa-file-signature"></i> {{ texts.partTime | localize }}
                </li>
                <li class="list-inline-item mb-2" *ngIf="project.Profile?.IsFullTime && project.Profile?.IsPartTime">
                  <i class="me-1 size-1 fa-sharp fa-solid fa-file-signature"></i> {{ texts.partOrFullTime | localize }}
                </li>
              </ul>
            </div>
          </div>
        </div>

      </app-editable-section>

    </div>
  </div>
</div>

<app-project-base-user-card [project]="project"></app-project-base-user-card>

<div class="card mt-5">
  <div class="card-header">
    <h5 class="card-title">Anforderungen</h5>
  </div>
  <div class="card-body">
    <div class="row" *ngIf="project?.Profile?.Requirements">

      <div class="col-12">
        <app-editable-section [isEditable]="isEditable" [isEditing]="editRequirements"
          (onEdit)="startEdit()">

          <div class="row">
            <div class="col-11" *ngIf="!editRequirements">
              <div class="mb-2 small text-muted">Must-Haves:</div>
              <sc-requirements-editor-list [project]="project" [hideInvisible]="true" [readonly]="true"
                priority="MustHave" [showCore]="false" [language]="loc.language"></sc-requirements-editor-list>

              <div class="mb-2 mt-3 small text-muted">Nice-to-Haves:</div>
              <sc-requirements-editor-list [project]="project" [readonly]="true"
                [hideInvisible]="true" priority="NiceToHave" [language]="loc.language"></sc-requirements-editor-list>

            </div>

            <div class="col-11" *ngIf="editRequirements">
              <div class="row">
                <div class="col-12">
                  <sc-requirements-editor [readonly]="!isEditable"
                    [isInEditMode]="editRequirements" [project]="project" [hideInvisible]="true"
                    [language]="loc.language" (change)="save()"></sc-requirements-editor>
                </div>
                <div class="col-12">
                  <a class="btn btn-lg btn-secondary mt-4" [href]="project.BriefingLink" target="_blank">
                    {{ texts.bookConsultation | localize }}
                    <i class="fa-sharp fa-solid fa-arrow-right ms-2"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </app-editable-section>
      </div>
    </div>
  </div>

</div>

<div class="card mt-5" *ngIf="project?.Type == 'Full'">
  <div class="card-header">
    <h5 class="card-title">Jobsite</h5>
  </div>
  <div class="card-body">
    <a class="btn btn-secondary" href="/projects/{{ project.Id }}/jobsite" target="_blank">{{ texts.viewJobsite | localize }}<i
        class="fa-sharp fa-solid fa-arrow-right ms-2"></i></a>
  </div>

</div>

<div class="card mt-5">
  <div class="card-header">
    <h5 class="card-title">Aktivitäten</h5>
  </div>
  <div class="card-body card-body-list">
    <app-project-activities [project]="project"></app-project-activities>
  </div>
</div>



<sc-modal size="lg" #editModal>
  <sc-modal-header>
    {{ texts.modal.title | localize }}
  </sc-modal-header>
  <sc-modal-body>
    <sc-form *ngIf="project">

      <sc-form-row [label]="texts.modal.jobTitle | localize">
        <input [(ngModel)]="project.Name" />
      </sc-form-row>

      <sc-form-row [label]="texts.modal.locations | localize">
        <sc-editor-location-list [(locations)]="project.Profile.Locations"
          [language]="loc.language"></sc-editor-location-list>
      </sc-form-row>

      <sc-form-row [label]="texts.modal.salary | localize" *ngIf="!isSalaryHidden(project.Id)">
        <div class="row align-items-center w-100">
          <div class="col">
            <input name="MinSalary" type="number" [(ngModel)]="project.Profile.Compensation.MinSalary" />
          </div>
          <div class="col-auto px-0">
            {{ texts.modal.to | localize }}
          </div>
          <div class="col">
            <input name="MaxSalary" type="number" [(ngModel)]="project.Profile.Compensation.MaxSalary" />
          </div>
          <div class="col-2 ps-0">
            <input name="SalaryCurrency" [(ngModel)]="project.Profile.Compensation.SalaryCurrency" />
          </div>
        </div>
      </sc-form-row>

      <sc-form-row [label]="texts.modal.remoteShare | localize">
        <input [(ngModel)]="project.Profile.MaxRemote" type="number" />
      </sc-form-row>


      <sc-form-row [label]="texts.modal.employmentType | localize">
        <select class="custom-select custom-select-sm" [(ngModel)]="project.Profile.EmploymentType">
          <option value="Permanent">{{ texts.modal.employmentPermanent | localize }}</option>
          <option value="Interim">{{ texts.modal.employmentInterim | localize }}</option>
          <option value="Freelancer">{{ texts.modal.employmentFreelancer | localize }}</option>
          <option value="SelfEmployed">{{ texts.modal.employmentSelfEmployed | localize }}</option>
          <option value="Internship">{{ texts.modal.employmentInternship | localize }}</option>
        </select>
      </sc-form-row>
      <sc-form-row [label]="texts.modal.fullTimeLabel | localize">
        <select class="custom-select custom-select-sm" [(ngModel)]="project.Profile.IsFullTime">
          <option [ngValue]="true">{{ texts.modal.yes | localize }}</option>
          <option [ngValue]="false">{{ texts.modal.no | localize }}</option>
        </select>
      </sc-form-row>

      <sc-form-row [label]="texts.modal.partTimeLabel | localize">
        <select class="custom-select custom-select-sm" [(ngModel)]="project.Profile.IsPartTime">
          <option [ngValue]="true">{{ texts.modal.yes | localize }}</option>
          <option [ngValue]="false">{{ texts.modal.no | localize }}</option>
        </select>
      </sc-form-row>

    </sc-form>
  </sc-modal-body>
  <sc-modal-footer>
    <button class="btn btn-dark" (click)="save(); editModal.dismiss()">{{ texts.modal.done | localize }}</button>
  </sc-modal-footer>
</sc-modal>